<template>
  <div class="nav-button-container cursor-pointer" :class="{ highlight }" @click="$emit('click')">
    <b-img v-if="details.iconImageSrc" :src="details.iconImageSrc" class="nav-icon-button" />
    <font-awesome-icon
      v-else
      class="fa-icon-as-button nav-icon-button"
      :icon="details.defaultIcon"
      style="padding: 0.6em"
    />

    <label :for="details.key" class="nav-button-label cursor-pointer">
      {{ details.label }}
    </label>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { NavButtonDetails, useNavButtonsStore } from '@/store/public/navButtons'
import { NavButtonKey } from '@/types'

const props = {
  btnKey: {
    type: String as PropType<NavButtonKey>,
    require: true,
  },
  highlight: {
    type: Boolean,
    default: false,
  },
}

@Component
export default class NavButton extends Vue.extend({ props }) {
  navButtonsStore = useNavButtonsStore()

  get details(): NavButtonDetails {
    return this.navButtonsStore.allBtns[this.btnKey]
  }
}
</script>

<style lang="scss" scoped>
.nav-button-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  margin: 0.2em 0;
  width: 70px;
  height: 70px;
  align-items: center;
  background: #9d9fa2;
  color: white;
  border-radius: var(--border-radius) 0 0 var(--border-radius);
  transition: all 0.3s;
  &:hover {
    width: 75px;
  }
  .nav-button-label {
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
    margin-bottom: 0;
  }
  svg {
    padding: 0.2em !important;
    width: 32px;
    height: 32px;
  }
  &.slide-enter,
  &.slide-leave-to {
    transform: translateX(100%);
  }
}

.nav-icon-button {
  height: 2.5em;
  width: 2.5em;
}

.button-width {
  width: 3.5em;
}

.cursor-pointer {
  cursor: pointer;
}

.highlight {
  width: 75px;
  background: #5e5f61;
}
</style>
